<template>
  <b-container>
     <b-toast title="Pass Saved" static no-auto-hide>
       Pass saved
    </b-toast>

      <form @submit.prevent="createPass"> 

        
        <b-alert
          :show="error"
          variant="danger"
        >
        {{ error }}
        </b-alert>


        <b-row>
        <b-col cols="8" sm="12" lg="8" md="8" xs="12">
        
        <b-form-group label="Full name">
          <b-form-input
            v-model="name"
            type="text"
            class="form-field"
          ></b-form-input>
        </b-form-group>

        <b-row v-if="isAdmin">
          <b-col cols="12">
            <b-form-group label="Organisation">
              <b-form-select v-model="organisationId" :options="organisations" class="form-field">
              </b-form-select>
            </b-form-group>
         </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Pass Type">
              <b-form-select v-model="passType" :options="passTypes" class="form-field">
                <template v-slot:first>
                  <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                </template>
              </b-form-select>
            </b-form-group>
         </b-col>
        </b-row>

        <b-row v-if="this.getDuration">
          <b-col cols="6" sm="12" md="6">
            <b-form-group
            label="Start date"
          > 
            <b-form-datepicker v-model="startDate" class="form-field"></b-form-datepicker>
            </b-form-group>
          </b-col>

          <b-col cols="6" sm="12" md="6">
            <b-form-group label="End date">
              <b-form-datepicker v-model="endDate" class="form-field"></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

            <b-form-group
            label="RFID"
            v-if="isEditing"
          > 
            <b-form-input
              v-model="rfid"
              type="number"
              :class="{'form-field': true}"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Membership #" v-if="allowManualBarcode">
            <b-form-input
              v-model="barcode"
              v-if="allowManualBarcode"
              type="number"
              :class="{'form-field': true}"
            ></b-form-input>
          </b-form-group>


          <b-form-group label="Notes">          
            <b-textarea
              v-model="notes" 
              type="text"
              class="form-field"
            >
            </b-textarea> 
          </b-form-group>

          <b-form-checkbox type="checkbox" v-model="disabled">Disabled</b-form-checkbox>
          <b-form-checkbox type="checkbox" v-model="billable">Billable</b-form-checkbox>

          <div v-if="hasMembershipPass">
            <b-form-checkbox type="checkbox" v-model="isSeasonPass" true-value="true" false-value="false">Season Pass</b-form-checkbox>
            <b-form-checkbox type="checkbox" v-model="isPrivileged">Summit</b-form-checkbox>
          </div>
        </b-col>

        <b-col cols="4" sm="12" md="4" lg="4" xs="12">
          <div id="image-upload">
            <img src="/static/placeholder-image.png" id="uploaded-image" v-if="!imageUrl" /> 

            <div v-else>
              <img :src="imageUrl" id="uploaded-image" v-if="!showCropper" /> 
              
              <vue-cropper
                ref="cropper"
                v-else
                viewMode="1"
                :src="imageUrl"
                class="cropper"
                :aspectRatio="0.76"
              />

              
            </div>

            <b-btn variant="secondary" @click="choosePhoto">Choose Photo</b-btn>

            <input
              type="file"
              style="display: none"
              ref=image
              accept="image/png,image/jpeg"
              @change="onImageChange"
            />
          </div>
        </b-col>
        </b-row>

        <b-btn variant="secondary" @click="submitPressed" :disabled="!checkFormFieldsAreFilled || isLoading" :class="{'disabled-form': !checkFormFieldsAreFilled}">
          <b-spinner v-if="isLoading"></b-spinner>
          <span v-else>{{ this.isEditing ? "Save" : "Create" }}</span>
        </b-btn>
      </form>
  </b-container>
</template>

<script>

import moment from "moment";
import VueCropper from "vue-cropperjs";
import 'cropperjs/dist/cropper.css';
import config from '../../constants';
import api from '../../api';



export default {
  props: {
    submit: Function,
    isEditing: Boolean,
    pass: Object
    
    
  },
  components: {
    VueCropper
  },
  data() {
    return {
      passId: null,
      name: '',
      passType: null,
      startDate: null,
      imageFile: null,
      imageUrl: null,
      endDate: null,
      disabled: false,
      billable: true,
      rfid: null,
      notes: null,
      isLoading: false,
      hasConnectedRfid: false,
      isPrinted: null,
      showCropper: false,
      error: null,
      expiryDate: null,
      passTypes: [
      ],
      isAdmin: api.userIsAdmin(),
      hasMembershipPass: api.getHasMembershipPass(),
      allowManualBarcode: api.getAllowManualBarcode(),
      organisations: [],
      organisationId: null,
      isSeasonPass: false,
      isPrivileged: false
    };
  },
  async mounted() {
    this.getPassTypes();
    if (this.isEditing) {
      
      this.name = this.pass.name;
      this.passType = this.pass.type_id;
      this.rfid = this.pass.rfid;
      this.notes = this.pass.notes;
      this.disabled = this.pass.disabled;
      this.billable = this.pass.billable;
      this.barcode = this.pass.barcode;
      this.passId = this.pass.id;
      this.organisationId = this.pass.organisation_id;
      this.endDate = moment(this.pass.expiry_date).format('YYYY-MM-DD');
      this.startDate = moment(this.endDate).subtract(30, "days").format('YYYY-MM-DD');
      this.isPrinted = this.pass.is_printed;

      if (this.pass.rfid) {
        this.hasConnectedRfid = true;
      }

      if (this.pass.image) {
        this.imageUrl = `${config.profilePhotosUrl}/${this.pass.image}`;
      }

      for (const option of this.pass.options) {
        this[option.optionName] = option.optionValue;
      }
    }

    if (api.userIsAdmin()) {
      const response = await api.getAllOrganisations();
      this.organisations = response.data.ret_msg.map(organisation => ({value: organisation.id, text: organisation.name}));

      if (!this.isEditing) {
        console.log(this.organisations);
        const mtChill = this.organisations.find(organisation => organisation.text === 'Mt Chill');
        if (mtChill) {
          this.organisationId = mtChill.value;
        }
      }
    }

    


  },
  methods: {
    choosePhoto() {
      this.$refs.image.click(); 
    },
    async getPassTypes() {
      const passTypes = await api.getAllPassTypes();
      const mappedPassTypes = passTypes.data.ret_msg
        .map(passType => ({
          text: passType.name,
          value: passType.id,
          duration: passType.days_limit,
          type: passType.type
        }));
      console.log(mappedPassTypes);
      this.passTypes = mappedPassTypes;
    },
    async getOrganisationPassTypes(organisationId) {
      const passTypes = await api.getOrganisationPassTypes(organisationId);
      const mappedPassTypes = passTypes.data.ret_msg
        .map(passType => ({
          text: passType.name,
          value: passType.id,
          duration: passType.days_limit,
          type: passType.type
        }));

      this.passTypes = mappedPassTypes;
    },
    getFormData(blob) {
      const data = new FormData();
      data.append('name', this.name);
      data.append('passTypeId', this.passType);

      data.append('disabled', this.disabled);
      data.append('billable', this.billable)

      if (this.hasMembershipPass) {
        data.append('isSeasonPass', this.isSeasonPass);
        data.append('isPrivileged', this.isPrivileged);
      }
      
      if (this.rfid) {
        data.append('rfid', this.rfid);
      }
      if (this.notes) {
        data.append('notes', this.notes);
      }

      if (this.organisationId) {
        data.append('organisationId', this.organisationId)
      }

      if (this.getDuration) {
        data.append('endDate', moment(this.endDate).valueOf());
      }

      if (this.barcode) {
        data.append('barcode', this.barcode);
      }

      if (this.expiryDate) {
        data.append('expiryDate', this.expiryDate);
      }

      if (blob) {
        data.append('image', blob)
      }

      return data;
    },
    async submitPressed() {
      this.isLoading = true;
      this.error = null;

      let passId;
      const cropper = this.$refs.cropper;

      if (!cropper) {
        const data = this.getFormData();
        this.$emit('submitPressed', data);

        try {
          passId = await this.submit(data, this.passId);
        } catch (e) {
          if (e.response.status === 409) {
            this.error = 'The membership number already exists';
          } else if (e.response.data.errorCode === 'passholderAlreadyExists') {
            this.error = 'This passholder already exists';            
          } else if (e.response.data.errorCode === 'rfidAlreadyTaken') {
            this.error = 'RFID is already taken';
          } else {
            this.error = 'Unknown error occured';
          }
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        if (this.isEditing) {
          this.$bvToast.toast('Pass has successfully been edited', {
            title: "Pass edited",
            variant: "success",
            solid: true
          });  
        } else {
          console.log(passId);
          this.$router.push(`/passes/${passId}/edit`);
        }
        return;
      }

      this.$refs.cropper
      .getCroppedCanvas()
      .toBlob(async blob => {
        const data = this.getFormData(blob);
        const passId = await this.submit(data, this.passId);
        this.isLoading = false;

        if (this.isEditing) {
          this.$bvToast.toast('Pass has successfully been edited', {
            title: "Pass Edited",
            variant: "success",
            solid: true
          });  
        } else {
          this.$router.push(`/passes/${passId}/edit`);
        }
      });
    },
    onImageChange() {
      this.showCropper = true;
      const files = event.target.files;
      const imageName = files[0].name;
      const splittedImageName = imageName.split(" ");
      
      if (splittedImageName.length === 2) {
        this.name = imageName.split('.')[0]
      }


      const fileReader = new FileReader();


      fileReader.readAsDataURL(files[0]);
      fileReader.addEventListener("load", () => {
        this.imageUrl = null;
        this.imageFile = null;

        setTimeout(() => {
          this.imageUrl = fileReader.result;
          this.imageFile = files[0]
        }, 0);
      });
    },
 },
  watch: {
    startDate(value) {
      const duration = this.getDuration;
      if(duration === null) {
        return;
      }
      this.endDate = moment(value).add(duration, 'days').format("YYYY-MM-DD");
    },
    passType(newValue, oldValue) {
      if(!this.passTypes || this.passTypes.length === 0) {
        return;
      }
      const newPassType = this.passTypes.find(passType => passType.value === newValue);
      if (newPassType.type === 'Member') {
        this.expiryDate = moment()
        .add(100, "years")
        .startOf("year")
        .unix(); 
      } else {
        this.expiryDate = null;
      }

      const duration = this.getDuration;
      const oldDuration = oldValue && this.passTypes.find(passType => passType.value === oldValue).duration;

      if (oldValue) {
        // If the old pass type did not have a duration but the new one does, then reset the start and end date
        if (duration && !oldDuration) {
          this.startDate = null;
          this.endDate = null;
        } else if (!duration) {
          this.startDate = null;
          this.endDate = null;
        }
      }
    },
    organisationId(newValue) {
      this.getOrganisationPassTypes(newValue);
    }
  },
  computed: {
    getDuration() {
      if (!this.passType) return null;
      const pass = this.passTypes.find(passType => passType.value === this.passType);

      if (!pass) return null;

      if (pass.type !== "30 Day Pass") {
        return null;
      }
      
      return pass.duration;
    },
    checkFormFieldsAreFilled() {
      const requiredFieldsFilled = this.name && this.passType;
      return requiredFieldsFilled && this.passType && (this.getDuration && this.endDate) || !this.getDuration;
      return requiredFieldsFilled;
    }
  }
}
</script>

<style scoped>
.form-field {
}

#image-upload {
  display: flex;
  align-items: center;
  flex-direction: column;
}

#image-upload button {
  margin-top: 15px;
}

#uploaded-image {
  max-height: 200px;
  max-width: 100%;
}

.cropper {
  max-height: 200px;
}

.disabled-form {
  cursor: not-allowed;
}

.signify-rfid {
  background-color: rgb(220, 254, 186);
}

</style>


// WEBPACK FOOTER //
// src/components/common/PassForm.vue